<template>
  <div class="col-xl-4 col-lg-6 col-xs-12">
    <div class="card">
      <div class="card-body">
        <div class="media">
          <div class="p-1 text-xs-center bg-indigo bg-darken-1 media-left media-middle">
            <i 
              :class="iconClass"
              class="font-large-2 white"
            ></i>
          </div>
          <div class="p-1 media-body">
            <h5 style="text-transform: uppercase; font-weight: 700;">{{header}}</h5>
            <h5>{{subHeader}}</h5>
          </div>

          <div class="p-1 text-xs-center media-left media-bottom">
            <router-link :to="path" v-if="path!=null&&path!=''">
              <i class="icon-paper font-large-1 grey"></i>
            </router-link>
          </div>
          <slot>
            <ul class="list-group list-group-flush">
                <BalanceCardRow 
                  v-if="loading"
                  title="Загрузка..."
                  :value="null"
                />
                <BalanceCardRow 
                  v-else-if="!(balances && balances.length)"
                  title="Средства отсутствуют"
                  :value="null"
                />
                <BalanceCardRow 
                  v-for="balance in balances"
                  :key="balance.title"
                  :title="balance.title"
                  :value="balance.value"
                />
            </ul>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BalanceCardRow from "@/components/BalanceCardRow.vue";

export default {
  name: 'BalanceCard',
  props: {
    header: String,
    subHeader: String,
    iconClass:String,
    path: String,
    balances: Array,
    loading:Boolean,
  },
  components: {
    BalanceCardRow,
  }
}
</script>